// portal-user/portal-user.schema.ts
import { z } from "zod";
var PortalUserRoleSchema = z.enum([
  "flote_admin",
  "flote_supplier_admin",
  "sales_rep",
  "supplier_admin",
  "supplier_member",
  "supplier"
  // @deprecated
]);
var DbPortalUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  role: PortalUserRoleSchema,
  b2bwave_sales_rep_id: z.number().nullable(),
  supabase_user_id: z.string().nullable(),
  member_id: z.string().uuid().nullable(),
  is_active: z.boolean(),
  created_at: z.union([z.string(), z.date()]),
  updated_at: z.union([z.string(), z.date()])
});
var CreateDbPortalUserSchema = z.object({
  id: z.string().uuid().optional(),
  email: z.string().email(),
  name: z.string(),
  role: PortalUserRoleSchema,
  b2bwave_sales_rep_id: z.number().nullable().optional(),
  supabase_user_id: z.string().nullable().optional(),
  member_id: z.string().uuid().nullable().optional(),
  is_active: z.boolean().optional(),
  created_at: z.string().optional(),
  updated_at: z.string().optional()
});
var UpdateDbPortalUserSchema = CreateDbPortalUserSchema.partial();
var PortalUserSchema = z.object({
  id: z.string().uuid(),
  email: z.string().email(),
  name: z.string(),
  role: PortalUserRoleSchema,
  b2bwaveSalesRepId: z.number().nullable(),
  supabaseUserId: z.string().nullable(),
  memberId: z.string().uuid().nullable(),
  isActive: z.boolean(),
  createdAt: z.coerce.date(),
  updatedAt: z.coerce.date()
});
var PortalUserDtoSchema = z.object({
  id: z.string(),
  email: z.string().email(),
  name: z.string(),
  role: PortalUserRoleSchema,
  b2bwaveSalesRepId: z.number().nullable(),
  supabaseUserId: z.string().nullable(),
  memberId: z.string().nullable(),
  isActive: z.boolean(),
  createdAt: z.string(),
  updatedAt: z.string()
});
var CreatePortalUserDtoSchema = z.object({
  email: z.string().email(),
  name: z.string(),
  role: PortalUserRoleSchema,
  memberId: z.string().uuid().nullable().optional(),
  b2bwaveSalesRepId: z.number().nullable().optional(),
  isActive: z.boolean().optional()
});
var UpdatePortalUserDtoSchema = z.object({
  email: z.string().email().optional(),
  name: z.string().optional(),
  role: PortalUserRoleSchema.optional(),
  memberId: z.string().uuid().nullable().optional(),
  b2bwaveSalesRepId: z.number().nullable().optional(),
  isActive: z.boolean().optional()
});
var DbSalesRepBrandSchema = z.object({
  id: z.string().uuid(),
  portal_user_id: z.string().uuid(),
  brand_id: z.string().uuid(),
  assigned_by_portal_user_id: z.string().uuid().nullable(),
  created_at: z.union([z.string(), z.date()])
});
var CreateDbSalesRepBrandSchema = z.object({
  id: z.string().uuid().optional(),
  portal_user_id: z.string().uuid(),
  brand_id: z.string().uuid(),
  assigned_by_portal_user_id: z.string().uuid().nullable().optional(),
  created_at: z.string().optional()
});
var SalesRepBrandSchema = z.object({
  id: z.string().uuid(),
  portalUserId: z.string().uuid(),
  brandId: z.string().uuid(),
  assignedByPortalUserId: z.string().uuid().nullable(),
  createdAt: z.date()
});
var SalesRepBrandDtoSchema = z.object({
  id: z.string(),
  portalUserId: z.string(),
  brandId: z.string(),
  assignedByPortalUserId: z.string().nullable(),
  createdAt: z.string().datetime()
});
var CreateSalesRepBrandDtoSchema = z.object({
  portalUserId: z.string().uuid(),
  brandId: z.string().uuid(),
  assignedByPortalUserId: z.string().uuid().nullable().optional()
});
var DbSalesRepBrandWithBrandSchema = z.object({
  id: z.string().uuid(),
  portal_user_id: z.string().uuid(),
  brand_id: z.string().uuid(),
  assigned_by_portal_user_id: z.string().uuid().nullable(),
  created_at: z.union([z.string(), z.date()]),
  // Joined brand fields
  brand_name: z.string(),
  brand_logo: z.string().nullable(),
  brand_description: z.string().nullable()
});
var SalesRepBrandWithBrandSchema = z.object({
  id: z.string().uuid(),
  portalUserId: z.string().uuid(),
  brandId: z.string().uuid(),
  assignedByPortalUserId: z.string().uuid().nullable(),
  createdAt: z.date(),
  // Brand details
  brandName: z.string(),
  brandLogo: z.string().nullable(),
  brandDescription: z.string().nullable()
});
var SalesRepBrandWithBrandDtoSchema = z.object({
  id: z.string(),
  portalUserId: z.string(),
  brandId: z.string(),
  assignedByPortalUserId: z.string().nullable(),
  createdAt: z.string().datetime(),
  brandName: z.string(),
  brandLogo: z.string().nullable(),
  brandDescription: z.string().nullable()
});

export {
  PortalUserRoleSchema,
  DbPortalUserSchema,
  CreateDbPortalUserSchema,
  UpdateDbPortalUserSchema,
  PortalUserSchema,
  PortalUserDtoSchema,
  CreatePortalUserDtoSchema,
  UpdatePortalUserDtoSchema,
  DbSalesRepBrandSchema,
  CreateDbSalesRepBrandSchema,
  SalesRepBrandSchema,
  SalesRepBrandDtoSchema,
  CreateSalesRepBrandDtoSchema,
  DbSalesRepBrandWithBrandSchema,
  SalesRepBrandWithBrandSchema,
  SalesRepBrandWithBrandDtoSchema
};
